// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__umHPS","right":"styles_right__3tt-C"};